<template>
  <div>
    <!-- {{ getStudentFormFillUpSubject.form_fill_up.exam_code }} -->

    <div
      v-for="(elective_subject,
      index) in getStudentFormFillUpSubject.elective_subject"
      :key="index"
    >
      {{ amar_sub_gulo_status }}

      <slot
        v-if="
          (paper_group_set == null ||
            paper_group_set ===
              elective_subject[0].core_paper.paper_group.paper_group_set) &&
            (!isSingleGroupMode ||
              activeGroupName == null ||
              activeGroupName ===
                elective_subject[0].core_paper.paper_group.name)
        "
      >
        <v-toolbar flat dark>
          <v-toolbar-title>
            Elective Subject

            <small
              v-if="elective_subject[0].core_paper.paper_group.show_name == 1"
            >
              (Group {{ index }})
            </small>
          </v-toolbar-title>

          <v-divider class="mx-4" inset vertical></v-divider>

          <span
            v-if="getStudentFormFillUpSubject.form_fill_up.exam_code != 3302"
          >
            select any
            {{ elective_subject[0].core_paper.paper_group.number_of_paper }}
            of {{ elective_subject.length }}
          </span>

          <v-spacer></v-spacer>
        </v-toolbar>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="elective_subject"
          item-key="paper_code"
          class="elevation-1"
          hide-actions
        >
          <template v-slot:items="props">
            <tr
              :active="props.selected"
              @click="
                props.selected = !props.selected;
                getData(props.item.core_paper.paper_group.id);
              "
              v-if="
                !props.item.prev_grade &&
                  props.item.core_paper.paper_type_info.name == 'elective' &&
                  alt_paper_code.indexOf(props.item.paper_code) == -1 &&
                  groupVisibilityMap[props.item.core_paper.paper_group.name] &&
                  (!groupVisibilityMap[props.item.core_paper.paper_group.name]
                    .locked ||
                    selected_paper_code.indexOf(props.item.paper_code) !== -1)
              "
            >
              <td>
                <v-checkbox
                  :input-value="props.selected"
                  primary
                  hide-details
                ></v-checkbox>
              </td>

              <td>
                {{ props.item.core_paper.paper_name }}
              </td>

              <td class="text-xs-center">
                {{ props.item.core_paper.paper_code }}
              </td>

              <td class="text-xs-center">
                {{ props.item.core_paper.paper_types.paper_type }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    enableSubmit: {
      type: Number,
      required: true,
    },
  },

  computed: {
    getStudentFormFillUpSubject() {
      return this.$store.getters.getStudentFormFillUpSubject;
    },

    /*
     * Special Exam Codes
     * Existing 6702 logic + 5608 added
     */
    isSingleGroupMode() {
      const examCode = Number(
        this.getStudentFormFillUpSubject.form_fill_up.exam_code,
      );

      return [6702, 5608].includes(examCode);
    },

    /*
     * Existing logic untouched
     */
    activeGroupName() {
      if (!this.selected.length) return null;

      var first = this.selected[0];

      return (
        first.core_paper &&
        first.core_paper.paper_group &&
        first.core_paper.paper_group.name
      );
    },

    /*
     * Existing group locking logic untouched
     */
    groupVisibilityMap() {
      var map = {};

      var groups = this.getStudentFormFillUpSubject.elective_subject;

      if (!groups) return map;

      Object.entries(groups).forEach(
        function(entry) {
          var groupKey = entry[0];
          var items = entry[1];

          var required = 0;

          if (
            items &&
            items.length > 0 &&
            items[0].core_paper &&
            items[0].core_paper.paper_group &&
            items[0].core_paper.paper_group.number_of_paper
          ) {
            required = Number(items[0].core_paper.paper_group.number_of_paper);
          }

          var selectedCount = this.group_selected_count[groupKey] || 0;

          map[groupKey] = {
            required: required,
            selectedCount: selectedCount,
            locked: selectedCount >= required,
          };
        }.bind(this),
      );

      return map;
    },
  },

  data: () => ({
    amar_sub_gulo_status: "",

    selected: [],

    pagination: {},

    headers: [
      {
        text: "Select",
        align: "left",
        value: "",
        sortable: false,
      },
      {
        text: "Paper Name",
        align: "left",
        value: "core_paper.paper_name",
        sortable: false,
      },
      {
        text: "Paper Code",
        value: "core_paper.paper_code",
      },
      {
        text: "Paper Type",
        value: "core_paper.paper_types.paper_type",
      },
    ],

    paper_group_set: null,

    group_wise_no_of_paper: [],

    alt_paper_code: [],

    group_requirements: {},

    group_selected_count: {},

    selected_paper_code: [],

    hidden_groups: {},
  }),

  watch: {
    /*
     * Whenever selected papers change
     */
    selected(val) {
      this.group_selected_count = {};
      this.selected_paper_code = [];
      this.alt_paper_code = [];

      /*
       * Existing group-wise selected paper counting
       */
      val.forEach((element) => {
        var groupName =
          element.core_paper &&
          element.core_paper.paper_group &&
          element.core_paper.paper_group.name;

        if (!groupName) return;

        if (!this.group_selected_count[groupName]) {
          this.group_selected_count[groupName] = 0;
        }

        this.group_selected_count[groupName]++;

        this.selected_paper_code.push(element.paper_code);

        if (element.core_paper.alt_paper_code) {
          this.alt_paper_code.push(element.core_paper.alt_paper_code);
        }
      });

      /*
       * Get Exam Code
       */
      var examCode = Number(
        this.getStudentFormFillUpSubject.form_fill_up.exam_code,
      );

      var isValid = false;

      /*
       * ============================================
       * SPECIAL EXAM CODE: 6702 & 5608
       * ============================================
       *
       * Group selection logic untouched.
       *
       * Only Submit validation is dynamic.
       *
       * Example:
       *
       * Group 1: Select any 6 of 6
       * Required = 6
       *
       * Selected = 6
       *
       * Submit = ENABLE
       *
       * Another Example:
       *
       * Group 1: Select any 4 of 6
       * Group 2: Select any 2 of 4
       *
       * Total Required = 6
       *
       * Total Selected = 6
       *
       * Submit = ENABLE
       * ============================================
       */
      if ([6702, 5608].includes(examCode)) {
        /*
         * যে group থেকে প্রথম paper select করা হয়েছে,
         * সেই group-এর number_of_paper হবে required সংখ্যা।
         */

        var totalRequired = 0;

        if (
          val.length > 0 &&
          val[0].core_paper &&
          val[0].core_paper.paper_group
        ) {
          totalRequired = Number(
            val[0].core_paper.paper_group.number_of_paper || 0,
          );
        }

        console.log("================================");
        console.log("SPECIAL EXAM CODE:", examCode);
        console.log(
          "Selected Group:",
          val.length > 0 ? val[0].core_paper.paper_group.name : null,
        );
        console.log("Total Required:", totalRequired);
        console.log("Total Selected:", val.length);

        /*
         * Selected group-এর যতটি paper select করতে বলবে,
         * ঠিক ততটি select হলেই Submit Enable হবে।
         */
        isValid = totalRequired > 0 && val.length === totalRequired;

        console.log("Special Exam Valid:", isValid);
        console.log("================================");
      } else {
        /*
         * ============================================
         * OTHER EXAM CODES
         * Existing validation untouched
         * ============================================
         */
        isValid = Object.keys(this.group_requirements).every((group) => {
          var required = Number(this.group_requirements[group] || 0);

          var selected = this.group_selected_count[group] || 0;

          return selected >= required;
        });
      }

      /*
       * Debug
       */
      console.log("================================");
      console.log("Exam Code:", examCode);
      console.log("Selected Papers:", val.length);
      console.log("Selected Paper Codes:", this.selected_paper_code);
      console.log("Group Selected Count:", this.group_selected_count);
      console.log("Is Valid:", isValid);
      console.log("Emit:", isValid ? 1 : 0);
      console.log("================================");

      /*
       * Enable / Disable Submit button
       */
      this.$emit("anable", isValid ? 1 : 0);

      /*
       * Update selected elective subjects
       */
      this.$parent.$parent.selected.elective_subject = val;
    },
  },

  methods: {
    /*
     * Existing getData logic untouched
     */
    getData() {
      var electiveGroups = this.getStudentFormFillUpSubject.elective_subject;

      if (!electiveGroups) return;

      this.group_requirements = {};

      Object.entries(electiveGroups).forEach((entry) => {
        var groupKey = entry[0];
        var arr = entry[1];

        if (!arr || !arr.length) return;

        var group = arr[0].core_paper.paper_group;

        if (!group) return;

        this.group_requirements[groupKey] = Number(group.number_of_paper || 0);
      });
    },

    /*
     * Existing toggle logic untouched
     */
    toggle(item) {
      var group = item.core_paper.paper_group.name;

      var code = item.paper_code;

      var exists = this.selected.some(function(p) {
        return p.paper_code === code;
      });

      if (!exists) {
        this.selected = this.selected.filter(function(p) {
          return p.core_paper.paper_group.name !== group;
        });

        this.selected.push(item);

        this.$set(this.hidden_groups, group, code);
      } else {
        this.selected = this.selected.filter(function(p) {
          return p.paper_code !== code;
        });

        this.$delete(this.hidden_groups, group);
      }
    },
  },

  created() {
    this.getData();
  },
};
</script>
